
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'

export default {
    name: 'ForeignExchange',
    components: { BlogTextColor },
}
